import { useEffect, useState } from 'react'
import { useUserStore } from 'Store/User'
import { useChartStore, ProjectStatusData } from 'Store/chart'
import moment from 'moment'
import { shallow } from 'zustand/shallow'

const MOCK_DATA_STAT_BOXES = [
  {
    img: '/media/icons/total-project.svg',
    number: 721,
    title: 'Total Projects',
    percentage: 4,
  },
  {
    img: '/media/icons/total-completed.svg',
    number: 239,
    title: 'Total Completed',
    percentage: 4,
  },
  {
    img: '/media/icons/total-canceled.svg',
    number: 65,
    title: 'Total Canceled',
    percentage: -25,
  },
  {
    img: '/media/icons/total-in-progress.svg',
    number: 156,
    title: 'Total Projects',
    percentage: -12,
  },
  {
    img: '/media/icons/total-in-progress.svg',
    number: 10,
    title: 'Total On-Hold',
    percentage: 40,
  },
]

const MOCK_MAINTENANCE: any[] = [
  {
    label: 'ฝนตก',
    value: 50,
  },
  {
    label: 'เครื่องจักรเสีย',
    value: 8,
  },
  {
    label: 'รอลูกค้า',
    value: 25,
  },
  {
    label: 'รอสรุปความยาว',
    value: 69,
  },
  {
    label: 'วันหยุด',
    value: 17,
  },
  {
    label: 'ฟื้นฟู',
    value: 70,
  },
  {
    label: 'อุปสรรคใต้ดิน',
    value: 30,
  },
]

const MOCK_PROJECT: any[] = [
  {
    label: 'Project A',
    value: 50,
  },
  {
    label: 'Project B',
    value: 8,
  },
  {
    label: 'Project C',
    value: 25,
  },
  {
    label: 'Project D',
    value: 69,
  },
  {
    label: 'Project E',
    value: 17,
  },
]

const ViewModel = () => {
  ////////
  // V1 //
  ////////

  const [stat, setStat] = useState<any[]>([])
  const [maintenance, setMaintenance] = useState<any[]>([])
  const [project, setProject] = useState<any[]>([])

  const fetchStat = async () => {
    try {
      setStat(MOCK_DATA_STAT_BOXES)
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchMaintenance = async () => {
    try {
      setMaintenance(MOCK_MAINTENANCE)
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchProject = async () => {
    try {
      setProject(MOCK_PROJECT)
    } catch (err: any) {
      console.log(err)
    }
  }

  useEffect(() => {
    const action = async () => {
      await fetchStat()
      await fetchMaintenance()
      await fetchProject()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    action()
  }, [])

  ////////
  // V1 //
  ////////

  ////////
  // V2 //
  ////////

  const { rawSales, getSales } = useUserStore(
    state => ({
      rawSales: state.data || [],
      getSales: state.getAll,
    }),
    shallow
  )

  const INITIAL_START_DATE = moment().tz('Asia/Bangkok').startOf('month').toDate()
  const INITIAL_END_DATE = moment().tz('Asia/Bangkok').toDate()

  const [startDate, setStartDate] = useState<Date>(INITIAL_START_DATE)
  const [endDate, setEndDate] = useState<Date>(INITIAL_END_DATE)
  const [dataType, setDataType] = useState<'month' | 'daily'>('month')
  const dataTypeOptions = [
    { label: 'รายเดือน', value: 'month' },
    { label: 'รายวัน', value: 'daily' },
  ]
  const [divisionList, setDivisionList] = useState<string[]>([])
  const divisionOptions = divisionList.map(division => ({ label: division, value: division }))
  const [selectedDivision, setSelectedDivision] = useState<string[]>([])

  const projectStateOptions = [
    { label: 'ทั้งหมด', value: 'all' },
    { label: 'รอเปิดงาน', value: 'pending' },
    { label: 'กำลังดำเนินการ', value: 'in-progress' },
    { label: 'เสร็จสิ้น', value: 'completed' },
  ]
  const [selectedProjectState, setSelectedProjectState] = useState<string>('all')

  const [jobStatisticFilterData, setJobStatisticFilterData] = useState<{
    year: number
    saleUserId?: string | null
  }>({
    year: moment().tz('Asia/Bangkok').year(),
    saleUserId: null,
  })
  const yearOptions = Array.from({ length: 10 }).map((_, index) => {
    const year = moment().tz('Asia/Bangkok').year() - index
    return { label: year.toString(), value: year }
  })
  const sales = rawSales
    .filter(u => u.roleId === 7)
    .map(s => ({
      label: s.fullName,
      value: s.id,
    }))

  const [allPileChartData, setAllPileChartData] = useState<{
    categories: string[]
    data: number[]
  }>({
    categories: [],
    data: [],
  })
  const [successPileData, setsuccessPileData] = useState<{
    categories: string[]
    data: number[]
  }>({
    categories: [],
    data: [],
  })

  const [unsuccessPieChartData, setUnsuccessPieChartData] = useState<{
    categories: string[]
    data: number[]
  }>({
    categories: [],
    data: [],
  })

  const [successfulPileHolesData, setSuccessfulPileHolesData] = useState<{
    categories: string[]
    data: any[]
  }>({
    categories: [],
    data: [],
  })
  const [successfulPileHolesItemsData, setSuccessfulPileHolesItemsData] = useState<{
    categories: string[]
    data: Array<{
      name: string
      data: number[]
      itemCode?: string
      itemTitle?: string
    }>
  }>({
    categories: [],
    data: [],
  })

  const [StatsTypeOfPile, setStatsTypeOfPile] = useState<{
    categories: string[]
    series: Array<{
      name: string
      data: number[]
    }>
  }>({
    categories: [],
    series: [],
  })

  const [issueData, setIssueData] = useState<{
    categories: string[]
    data: number[]
  }>({
    categories: [],
    data: [],
  })

  const [projectStatusData, setProjectStatusData] = useState<ProjectStatusData>({
    projects: [],
    data: [],
  })

  const [jobStatisticsData, setJobStatisticsData] = useState<any>({})

  const fetchMasterData = async () => {
    try {
      const { success, data } = await useChartStore.getState().getDivisionList()
      if (success && data) {
        setDivisionList(data)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchAllPileData = async () => {
    try {
      const filterStartDate = startDate
      const filterEndDate = endDate

      // Only make API call if both dates are provided
      if (!filterStartDate || !filterEndDate) {
        return
      }

      const { success: allSuccess, data: allData } = await useChartStore.getState().getAll(
        moment(filterStartDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
          .toISOString(),
        moment(filterEndDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999,
          })
          .toISOString(),
        selectedDivision,
        selectedProjectState !== 'all' ? selectedProjectState : undefined
      )
      if (allSuccess && allData) {
        const colors = ['#FF5B5B', '#2D9CDB', '#F2C94C', '#6FCF97', '#9B51E0']
        const responseData = allData as unknown as { categories: string[]; data: number[] }
        const transformedData = {
          categories: responseData.categories || [],
          data: responseData.data || [],
          colors: colors.slice(0, responseData.categories?.length || 0),
        }
        setAllPileChartData(transformedData)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchSuccessfulPileData = async () => {
    try {
      const filterStartDate = startDate
      const filterEndDate = endDate

      // Only make API call if both dates are provided
      if (!filterStartDate || !filterEndDate) {
        return
      }

      const { success, data } = await useChartStore.getState().getSuccessful(
        moment(filterStartDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
          .toISOString(),
        moment(filterEndDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999,
          })
          .toISOString(),
        selectedDivision
      )
      if (success && data) {
        const colors = ['#FF5B5B', '#2D9CDB']
        const responseData = data as unknown as { categories: string[]; data: number[] }
        const transformedData = {
          categories: responseData.categories || [],
          data: responseData.data || [],
          colors: colors,
        }
        setsuccessPileData(transformedData)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchUnsuccessfulPileData = async () => {
    try {
      const filterStartDate = startDate
      const filterEndDate = endDate

      // Only make API call if both dates are provided
      if (!filterStartDate || !filterEndDate) {
        return
      }

      const { success: unsuccessSuccess, data: unsuccessData } = await useChartStore
        .getState()
        .getUnsuccessful(
          moment(filterStartDate)
            .tz('Asia/Bangkok')
            .set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0,
            })
            .toISOString(),
          moment(filterEndDate)
            .tz('Asia/Bangkok')
            .set({
              hour: 23,
              minute: 59,
              second: 59,
              millisecond: 999,
            })
            .toISOString(),
          selectedDivision
        )
      if (unsuccessSuccess && unsuccessData) {
        const colors = ['#FF5B5B', '#2D9CDB', '#F2C94C', '#6FCF97']
        const responseData = unsuccessData as unknown as { categories: string[]; data: number[] }
        const transformedData = {
          categories: responseData.categories || [],
          data: responseData.data || [],
          colors: colors.slice(0, responseData.categories?.length || 0),
        }
        setUnsuccessPieChartData(transformedData)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchSuccessfulPileHolesData = async () => {
    try {
      const filterStartDate = startDate
      const filterEndDate = endDate

      // Only make API call if both dates are provided
      if (!filterStartDate || !filterEndDate) {
        return
      }

      const { success, data } = await useChartStore.getState().getSuccessfulPileHolesTotal(
        moment(filterStartDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        moment(filterEndDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999,
          })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        selectedDivision,
        dataType
      )
      if (success && data) {
        const colors = ['#FF5B5B', '#2D9CDB']
        const responseData = data as unknown as { categories: string[]; series: any[] }
        const transformedData = {
          categories: responseData.categories || [],
          data: responseData.series || [],
          colors: colors,
        }
        setSuccessfulPileHolesData(transformedData)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchSuccessfulPileHolesItemsData = async () => {
    try {
      const filterStartDate = startDate
      const filterEndDate = endDate

      // Only make API call if both dates are provided
      if (!filterStartDate || !filterEndDate) {
        return
      }

      const { success, data } = await useChartStore.getState().getSuccessfulPileHoleItems(
        moment(filterStartDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        moment(filterEndDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999,
          })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        selectedDivision,
        dataType
      )

      if (success && data) {
        const responseData = data as unknown as {
          categories: string[]
          series: Array<{
            name: string
            data: number[]
            itemCode?: string
            itemTitle?: string
          }>
        }
        const transformedData = {
          categories: responseData.categories || [],
          data: responseData.series || [],
        }
        setSuccessfulPileHolesItemsData(transformedData)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchOtherData = async () => {
    try {
      // Fetch issue data from API
      const { success: issueSuccess, data: issueDataResponse } = await useChartStore
        .getState()
        .getIssue(selectedDivision)
      if (issueSuccess && issueDataResponse) {
        const colors = ['#b399fd']

        const category_state: Record<string, string> = {
          MACHINE_BREAK: 'เครื่องจักรเสียหาย',
          LOSS_TIME: 'รอลูกค้า',
          RAIN: 'ฝนตก',
          WAITING_SUMMARY: 'รอสรุปความยาว',
          RESTORATION: 'ฟื้นฟู',
          UNDERGROUND_OBSTACLE: 'อุปสรรคใต้ดิน',
        }

        const responseData = issueDataResponse as unknown as {
          categories: string[]
          data: number[]
        }
        const transformedData = {
          categories: (responseData.categories || []).map(
            category => category_state[category] || category
          ),
          data: responseData.data || [],
          colors: colors,
        }
        setIssueData(transformedData)
      }

      // Fetch project status data from API
      const { success: statusSuccess, data: statusData } = await useChartStore.getState().getStatus(
        moment(startDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
          .toISOString(),
        moment(endDate)
          .tz('Asia/Bangkok')
          .set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999,
          })
          .toISOString(),
        selectedDivision
      )
      if (statusSuccess && statusData) {
        setProjectStatusData(statusData)
      }

      // Fetch job statistics type data from API
      const { success: jobTypeSuccess, data: jobTypeData } = await useChartStore
        .getState()
        .getJobStatisticsType(
          moment(startDate)
            .tz('Asia/Bangkok')
            .set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0,
            })
            .toISOString(),
          moment(endDate)
            .tz('Asia/Bangkok')
            .set({
              hour: 23,
              minute: 59,
              second: 59,
              millisecond: 999,
            })
            .toISOString(),
          dataType,
          selectedDivision
        )
      if (jobTypeSuccess && jobTypeData) {
        const typedData = jobTypeData as unknown as {
          categories: string[]
          series: Array<{
            name: string
            data: number[]
          }>
        }
        setStatsTypeOfPile(typedData)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchProjectSalePerformanceData = async () => {
    try {
      // Implementation for fetching project sale performance data
      const { success, data } = await useChartStore.getState().getProjectSalesPerformance({
        year: jobStatisticFilterData.year,
        saleUserId: jobStatisticFilterData.saleUserId || undefined,
        dataType: dataType,
      })
      if (success && data) {
        setJobStatisticsData(data)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchData = () => {
    fetchUnsuccessfulPileData()
    fetchSuccessfulPileData()
    fetchAllPileData()
    fetchOtherData()
    fetchSuccessfulPileHolesData()
    fetchSuccessfulPileHolesItemsData()
  }

  useEffect(() => {
    fetchMasterData()
  }, [])

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, dataType, selectedDivision])

  useEffect(() => {
    fetchProjectSalePerformanceData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobStatisticFilterData, dataType])

  ////////
  // V2 //
  ////////

  return {
    // V1 //
    stat,
    maintenance,
    project,

    // V2 //
    // Data
    allPileChartData,
    successPileData,
    unsuccessPieChartData,
    StatsTypeOfPile,
    issueData,
    projectStatusData,
    jobStatisticsData,
    successfulPileHolesData,
    successfulPileHolesItemsData,
    // Filters Options
    jobStatisticFilterData,
    setJobStatisticFilterData,
    sales,
    yearOptions,
    projectStateOptions,
    divisionOptions,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    dataTypeOptions,
    dataType,
    setDataType,
    selectedDivision,
    setSelectedDivision,
    selectedProjectState,
    setSelectedProjectState,
  }
}

export default ViewModel
